import { useMemo } from 'react';
export function createCategorySlugToHeaderMapping(directCategories) {
  return Object.fromEntries(directCategories.map(_ref => {
    let {
      backendTitle,
      h1Header
    } = _ref;
    return [backendTitle, h1Header];
  }));
}
export default function useCategorySlugToHeaderMapping(directCategories) {
  return useMemo(() => createCategorySlugToHeaderMapping(directCategories), [directCategories]);
}